const LOCAL_STORAGE_TRANSITAIRE = 'pharmedistore_transitaire'

const TRANSITAIRE_MANAGER = {
  set: (value: number | null) => {
    if (typeof window !== 'undefined') {
      if (value === null) {
        window.localStorage.removeItem(LOCAL_STORAGE_TRANSITAIRE)
      } else {
        window.localStorage.setItem(LOCAL_STORAGE_TRANSITAIRE, String(value))
      }
    }
  },

  get: (): number | null => {
    if (typeof window !== 'undefined') {
      const value = window.localStorage.getItem(LOCAL_STORAGE_TRANSITAIRE)
      return value ? Number(value) : null
    }
    return null
  },

  reset: () => {
    if (typeof window !== 'undefined') window.localStorage.removeItem(LOCAL_STORAGE_TRANSITAIRE)
  },
}

export default TRANSITAIRE_MANAGER
